import Splide from '@splidejs/splide';

// let breakpoints = [576,768,992,1200];

document.addEventListener( 'DOMContentLoaded', function () {
  document.querySelectorAll('[data-splide]').forEach((elem) => {

    let numElem = elem.querySelectorAll('.splide__slide').length;

    let splide = new Splide(elem, {
      type : 'loop',
      perPage: 3,
      pagination: (numElem > 3) ? true : false,
      gap: '26px',
      autoplay: true,
      interval: 5000,
      breakpoints: {
        '992': {
          perPage: 2,
          pagination: (numElem > 2) ? true : false,
        },
        '576': {
          perPage: 1,
          pagination: (numElem > 1) ? true : false,
        },
      }
    }).mount();

    // splide.on( 'mounted updated', function (options) {
    //   let items = splide.Components.Elements.slides.length;

    //   if (items > splide.options.perPage) {
    //     splide.options.pagination = true;
    //   } else {
    //     splide.options.pagination = false;
    //   }

    //   Object.keys(options.breakpoints).forEach((breakpoint) => {
    //     let itemsPerPage = options.breakpoints[breakpoint].perPage;
    //     if (items > itemsPerPage) {
    //       splide.options.breakpoints[breakpoint].pagination = true;
    //     } else {
    //       splide.options.breakpoints[breakpoint].pagination = false;
    //     }
    //   });

    //   splide.refresh();
    // } );
  });
});

